



































import HeaderDesktop from 'library/components/layout/header/desktop'
import HeaderMobile from 'library/components/layout/header/mobile'
import LayoutFooter from 'library/components/layout/footer/footer'
import HeaderHeightMixin from 'library/mixins/header-height'

export default

	mixins: [ HeaderHeightMixin ]

	name: 'DefaultLayout'

	components: {
		HeaderDesktop
		HeaderMobile
		LayoutFooter
	}

	head: -> meta: [
		@$metaTag 'viewport', 'width=device-width, initial-scale=1, maximum-scale=1'
	]

	computed:
		globalDataLoaded: -> @$store.state.globals.desktopNavigation?
		showGlobalElements: -> @$store.state.layout.hideGlobalElements
		calculatedHeaderCSSVars: ->
			'--calculated-header': @headerHeight
			'--calculated-header-mobile': @mobileHeaderHeight
			'--calculated-banner': @bannerHeight
			'--calculated-banner-mobile': @bannerHeightMobile

